import { useCallback } from 'react';
import { useToast } from './toast-context';

export type CopyFeedback = {
  successTitle: string;
  successDescription?: string;
};

export type CopyToClipboard = (value: string, feedback: CopyFeedback) => Promise<void>;

export function useCopyToClipboard(): CopyToClipboard {
  const { success, info, error } = useToast();

  return useCallback<CopyToClipboard>(
    async (value, feedback) => {
      if (navigator.clipboard && navigator.clipboard.writeText) {
        try {
          await navigator.clipboard.writeText(value);
          success(feedback.successTitle, feedback.successDescription);
        } catch {
          error('Failed to copy to clipboard', 'The value has not been copied to your clipboard, please copy it manually');
        }
      } else {
        info('Select the text manually', 'Clipboard is not available in this browser');
      }
    },
    [success, info, error]
  );
}
